export enum UrlParamAction {
    Set = 'set',
    Append = 'append',
    Delete = 'delete'
}

interface IUpdateUrlParamsOptions {
    action: UrlParamAction;
    paramName: string;
    value?: string | string[];
}

/**
 * Updates the current URL's search parameters.
 *
 * @param options - The action (set, append, delete), paramName, and values
 */
export function updateUrlParams({ action, paramName, value }: IUpdateUrlParamsOptions) {
    const currentUrl = new URL(window.location.href);

    switch (action) {
        case UrlParamAction.Set:
            if (typeof value === 'string') {
                currentUrl.searchParams.set(paramName, value);
            } else if (Array.isArray(value)) {
                currentUrl.searchParams.delete(paramName);
                value.forEach(v => currentUrl.searchParams.append(paramName, v));
            }
            break;

        case UrlParamAction.Append:
            if (typeof value === 'string') {
                currentUrl.searchParams.append(paramName, value);
            } else if (Array.isArray(value)) {
                value.forEach(v => currentUrl.searchParams.append(paramName, v));
            }
            break;

        case UrlParamAction.Delete:
            currentUrl.searchParams.delete(paramName);
            break;

        default:
            throw new Error('Unknown action for updateUrlParams');
    }

    window.history.pushState({}, '', currentUrl.toString());
}
